import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import DOMPurify from "dompurify";
import {Outlet} from "react-router-dom";
import './LoginLayout.scss'

export const LoginLayout = () =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    const sanitizeHTML = (html : string) => {
        return {__html: DOMPurify.sanitize(html, { ADD_ATTR: ['target'] })};
    }

    return (
        <div className="d-flex flex-column cm-login-layout-page bg-body-secondary">
            <div className="cm-login-layout-logo">
                <img src={t(['login.logo'])} alt={t(['login.logo-alt'])}/>
            </div>

            <div className="cm-login-layout-header">
                {t(['login-layout-header']).length > 0 && <div dangerouslySetInnerHTML={sanitizeHTML(t(["login-layout-header"]))} />}
            </div>

            <div className="cm-login-layout-outlet bg-body-secondary">
                <Outlet/>
            </div>

            <div className="cm-login-layout-footer">
                {t(['login-layout-footer']).length > 0 && <div dangerouslySetInnerHTML={sanitizeHTML(t(["login-layout-footer"]))} />}
            </div>
        </div>
    );
}
